<script>
export default {
  name: 'view-upholstry',
  props: {
    value: { type: Object, default: () => {} }
  },
  data () {
    return {
      specs: {
        foam_type: null,
        seat_width: null,
        seat_depth: null
      }
    }
  },
  watch: {
    value: {
      handler (v) {
        if (v) this.specs = { ...v }
      },
      immediate: true
    }
  }
}
</script>
<template>
  <b-row no-gutters align-v="start" align-h="center">
    <b-col align-self="start">
      <h6 class="mt-4">{{ $t('specifications') }}</h6>
      <div class="d-flex justify-content-start align-items-start w-100">
        <div>
          <p class="p-0 my-2 mb-2">
            <i class="text-muted mr-2"
              >{{ $t(`attribute.color_outside.key`) }}:
            </i>
            {{ specs.color_outside }}
          </p>
          <p class="p-0 my-2 mb-4">
            <i class="text-muted mr-2"
              >{{ $t(`attribute.color_inside.key`) }}:
            </i>
            {{ specs.color_inside }}
          </p>
        </div>
        <img
          src="@/assets/images/forms/bekleding.png"
          alt
          style="max-width: 100%; opacity: 0.8"
          class="dimg-fluid ml-4"
          height="120"
        />
      </div>

      <p class="mb-2" v-for="part in specs.selected_parts" :key="part">
        <i class="far fa-check-square mr-2 mb-1"></i
        >{{ $t(`attribute.upholstry_part.${part}`) }}
        <span v-if="specs.other_parts && part === 'other'"
          >:
          <pre class="mt-2">{{ specs.other_parts }}</pre>
        </span>
      </p>
    </b-col>
  </b-row>
</template>
